// Famílias de categoria de transação → cor do chip (contorno, paleta
// dos tokens). Cor por família, não por nome exato — categoria nova cai
// numa família ou no cinza neutro. Usada na lista e na ficha.
export const transactionCategoryColor = (
  name: string
): "primary" | "success" | "warning" | "default" => {
  const n = (name || "").toLowerCase();
  if (n.includes("contribui")) return "success";
  if (n.includes("financeir")) return "primary";
  if (
    n.includes("alug") ||
    n.includes("comodato") ||
    n.includes("patrimoni") ||
    n.includes("predia") ||
    n.includes("campestre")
  )
    return "warning";
  return "default";
};

export const validateCompetencia = (value: any) => {
  if (!value) return "Campo obrigatório";
  const currentYear = new Date().getFullYear();
  const isValidYear = (year: string) => {
    const parsedYear = parseInt(year);
    return (
      !isNaN(parsedYear) && parsedYear >= 1900 && parsedYear <= currentYear
    );
  };

  if (
    value !== "VITAL" &&
    value !== "PENDENTE" &&
    !value.match(/^(\d{4})(\.[12])?$/) &&
    !isValidYear(value)
  ) {
    return "Formato inválido. Utilize: 'VITAL', 'PENDENTE',  'AAAA' ou 'AAAA.S'";
  }
  // if it has semester, but semester is empty
  if (value.split(".")[1] && value.split(".")[1] === "") {
    return "Semestre não informado. Utilize '1' ou '2'.";
  }
  const semesterIsNumber = value.split(".")[1] && !isNaN(value.split(".")[1]);
  if (value.match(/^\d{4}\.(1|2)$/)) {
    return undefined;
  } else if (value.match(/^\d{4}\.\d{1,2}$/)) {
    return "Formato inválido. O semestre deve ser '1' ou '2'.";
  }
  if (value.split(".")[1] && !semesterIsNumber) {
    return "Formato inválido. O semestre deve ser '1' ou '2'.";
  }
  return undefined;
};
